import { ca } from '@cian/analytics';
import { NEWBUILDING_OFFERS_CAROUSEL_OPTIONS } from 'shared/constants/newbuildingCarouselOffers';
import { INewbuildingOffer } from 'shared/types/newbuildingOffersCarousel';

import { getNewbuildingOffersPositions } from '../../utils/newbuildingOffersCarousel';

export const trackNewbuildingClick = ({
  offerId,
  position,
  newbuildingId,
}: {
  position: number;
  offerId: number;
  newbuildingId: number;
}) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click',
    label: 'upsale_carousel_to_cardjk',
    products: [
      {
        id: offerId,
        position: position + 1,
        offerType: 'offer',
        extra: {
          parentId: newbuildingId,
        },
      },
    ],
  });
};

export const trackOfferClick = ({
  position,
  offerId,
  newbuildingId,
}: {
  position: number;
  offerId?: number;
  newbuildingId?: number;
}) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click',
    label: 'upsale_carousel_to_card',
    products: [
      {
        id: offerId,
        position: position + 1,
        offerType: offerId ? 'offer' : 'kpn',
        extra: {
          parentId: newbuildingId ?? null,
        },
      },
    ],
  });
};

export const trackOffersCarouselShow = ({ offers, isKpn }: { offers: INewbuildingOffer[]; isKpn: boolean }) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'show_sopr',
    label: 'upsale_offers_carousel',
    products: getNewbuildingOffersPositions({
      step: NEWBUILDING_OFFERS_CAROUSEL_OPTIONS.slidesPerView,
      activeSlideIndex: 0,
      offers,
      isKpn,
    }),
  });
};

export const trackCarouselChange = ({
  offers,
  activeSlideIndex,
  isKpn,
}: {
  activeSlideIndex: number;
  offers: INewbuildingOffer[];
  isKpn: boolean;
}) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click',
    label: 'upsale_carousel_scroll',
    products: getNewbuildingOffersPositions({
      step: NEWBUILDING_OFFERS_CAROUSEL_OPTIONS.slidesPerView,
      activeSlideIndex,
      offers,
      isKpn,
    }),
  });
};
